import API from './API'
import { trackingHeaders } from 'utils/trackingHeaders'

var ReportAPI = {
  // These reports are export-only endpoints, so the controller logs the export
  // server-side. The X-Delve-Page header (from trackingContext) tells it which
  // surface triggered the export. Code x Code can fan out into multiple chunked
  // requests, so trackingContext.logExport flags only the first one to log.
  getTranscriptCodesReport: function(project_id, trackingContext = null) {
    return API.get(`/api/projects/${project_id}/transcript_codes_report`, trackingHeaders(trackingContext));
  },

  getCodesVCodesReport: function(project_id, code_ids, op='or', trackingContext=null) {
    const params = !!code_ids && code_ids.length > 0 ? {code_ids, op} : {};
    if (trackingContext && trackingContext.logExport) {
      params.log_export = true;
    }

    return API.post(`/api/projects/${project_id}/codes_codes_report`, params, trackingHeaders(trackingContext));
  },

  getDescriptorVCodesReport: function(project_id, trackingContext = null) {
    return API.get(`/api/projects/${project_id}/descriptor_codes_report`, trackingHeaders(trackingContext));
  },

  getDemographicsReport: function(project_id, trackingContext = null) {
    return API.get(`/api/projects/${project_id}/demographics_report`, trackingHeaders(trackingContext));
  },

  getCodeReport: function(code_id) {
    return API.get(`/api/codes/${code_id}/code_report`);
  }
};

export default ReportAPI
